import translations from './translations'

translations.add('es', {
    amount: 'Importe',
    bank: 'Banco',
    reference: 'Referencia'
})
